import React, { createContext, useContext } from "react";

import { Navigation } from "@/types";

const NavigationContext = createContext<Navigation | undefined>(undefined);

export const NavigationProvider: React.FC<{ navigation: Navigation; children: React.ReactNode }> = ({
  navigation,
  children,
}) => (
  <NavigationContext.Provider value={navigation}>
    {children}
  </NavigationContext.Provider>
);

/** The app's navigation menu config */
export const useAppNavigation = () => {
  const navigation = useContext(NavigationContext);
  if (navigation === undefined) {
    throw new Error("useAppNavigation must be used within a NavigationProvider");
  }
  return navigation;
};
